import classNames from 'classnames';
import type { ChangeEventHandler } from 'react';

import OptionContainer from './OptionContainer';
import OptionLabel from './OptionLabel';

interface Props {
  name: string;
  value: string;
  onChange: (value: string, checked: boolean) => void;
  isSelected: boolean;
}

const CheckboxOption = ({ name, value, onChange, isSelected }: Props) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => onChange(value, e.currentTarget.checked);

  return (
    <OptionContainer paddingClassName="px-0 py-1">
      <input
        name={name}
        id={name}
        type="checkbox"
        className="hidden"
        onChange={handleChange}
        value={value}
        aria-hidden
      />
      <label htmlFor={name} className="inline-flex flex-row items-center gap-x-2">
        <span
          className={classNames(
            'flex h-4 w-4 items-center justify-center rounded-md border',
            isSelected ? 'border-[#111827]' : 'border-[##6B7280]',
          )}
        >
          {isSelected ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#111827" stroke="#111827" />
              <path
                d="M12.104 5.53608L12.0991 5.53018L12.0938 5.52467C11.9337 5.35887 11.6755 5.35845 11.5149 5.52341L7.32964 9.72698L5.29657 7.67973C5.13598 7.51467 4.87766 7.51505 4.71753 7.68089C4.56081 7.84318 4.56081 8.09929 4.71753 8.26158L4.71751 8.2616L4.71949 8.26358L6.8358 10.3947C6.9687 10.5317 7.1496 10.6 7.31783 10.6C7.50031 10.6 7.66872 10.5299 7.79976 10.3948L12.0652 6.11067C12.2386 5.94943 12.2371 5.69679 12.104 5.53608ZM7.41493 9.81286L7.41338 9.8113C7.41392 9.81183 7.41441 9.81236 7.41491 9.81288L7.41493 9.81286Z"
                fill="#F9FAFB"
                stroke="#F9FAFB"
                strokeWidth="0.4"
              />
            </svg>
          ) : null}
        </span>
        <OptionLabel isSelected={isSelected}>{value}</OptionLabel>
      </label>
    </OptionContainer>
  );
};

export default CheckboxOption;
